"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Downgrades = void 0;
var _InnerPopupWrapperStyled = require("../../InnerPopupWrapper/InnerPopupWrapperStyled");
var _Button = _interopRequireDefault(require("../../Button"));
var _popupSlice = require("../../../redux/popupSlice");
var _reactI18next = require("react-i18next");
var _store = require("../../../redux/store");
var _OfferSwitchCard = _interopRequireDefault(require("../../OfferSwitchCard"));
var _jsxRuntime = require("react/jsx-runtime");
const Downgrades = _ref => {
  var _updateSubscription$o;
  let {
    downgradesListFiltered,
    handleClick
  } = _ref;
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const dispatch = (0, _store.useAppDispatch)();
  const {
    updateSubscription
  } = (0, _store.useAppSelector)(_popupSlice.selectPopupManager);
  const offerId = (updateSubscription === null || updateSubscription === void 0 || (_updateSubscription$o = updateSubscription.offerData) === null || _updateSubscription$o === void 0 ? void 0 : _updateSubscription$o.offerId) || '';
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_InnerPopupWrapperStyled.ContentStyled, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.TitleStyled, {
        children: t('unsubscribe-popup.downgrade-instead', 'How about a plan downgrade instead of cancellation?')
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.TextStyled, {
        children: t('unsubscribe-popup.plans-proposal', 'Here are the plans that might suit your needs:')
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.DowngradesWrapperStyled, {
      children: downgradesListFiltered.map(downgradeOffer => {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.OfferCardWrapperStyled, {
          onClick: () => dispatch((0, _popupSlice.showPopup)({
            type: 'switchPlan',
            data: {
              offerData: {
                ...downgradeOffer
              },
              isPartOfCancellationFlow: true
            }
          })),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_OfferSwitchCard.default, {
            toOfferId: downgradeOffer.toOfferId,
            baseOfferId: offerId
          })
        }, downgradeOffer.toOfferId);
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.TextStyled, {
      children: t('unsubscribe-popup.still-cancel', 'Or still wants to cancel a subscription?')
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_InnerPopupWrapperStyled.ButtonWrapperStyled, {
      $removeMargin: true,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
        theme: "simple",
        onClickFn: () => dispatch((0, _popupSlice.hidePopup)()),
        children: t('unsubscribe-popup.back-button', 'Back to My Account')
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
        theme: "confirm",
        onClickFn: handleClick,
        children: t('unsubscribe-popup.unsubscribe-button-text', 'Unsubscribe')
      })]
    })]
  });
};

// eslint-disable-next-line import/prefer-default-export
exports.Downgrades = Downgrades;